class RoistatService {
  constructor () {
    this.isEnabled = false
    this.isReady = false

    this.delayedQueue = []
  }

  init (config) {
    if (config.roistat && config.roistat.key) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.innerHTML = `(function(w, d, s, h, id) {
          w.roistatProjectId = id; w.roistatHost = h;
          var p = d.location.protocol == "https:" ? "https://" : "http://";
          var u = /^.*roistat_visit=[^;]+(.*)?$/.test(d.cookie) ? "/dist/module.js" : "/api/site/1.0/"+id+"/init?referrer="+encodeURIComponent(d.location.href);
          var js = d.createElement(s); js.charset="UTF-8"; js.async = 1; js.src = p+h+u; var js2 = d.getElementsByTagName(s)[0]; js2.parentNode.insertBefore(js, js2);
      })(window, document, 'script', 'cloud.roistat.com', '${config.roistat.key}');`
      document.body.appendChild(script)

      this.isEnabled = true

      window.onRoistatAllModulesLoaded = () => {
        this.isReady = true
        this.handleDelayedQueue()
      }
    }
  }

  async handleDelayedQueue () {
    this.isProcessingDelayedQueue = true

    while (this.delayedQueue.length > 0) {
      const { type } = this.delayedQueue.shift()
      switch (type) {
        // case 'setVisit':
          // console.log('handleDelayedQueue.setVisit', payload.visitId)
          // // window.roistat.setVisit(payload.visitId)
          // break

        default:
          break
      }
    }

    this.isProcessingDelayedQueue = false
  }

  async waitHandlingDelayedQueueIfNeeded () {
    if (this.isProcessingDelayedQueue) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (this.isProcessingDelayedQueue) {
            clearInterval(interval)
            resolve()
          }
        }, 100)
      })
    }
  }

  getVisit () {
    if (!this.isEnabled || !this.isReady) {
      return null
    }

    return window.roistat.getVisit()
  }
}

const instance = new RoistatService()
export default instance
